
























import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppTwoColsCard from '@/components/AppTwoColsCard.vue'
import { CURRENT_USER } from '@/gql/auth'
import { OrderMixin } from '@/mixins'

@Component({
  components: {
    AppTwoColsCard
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    }
  }
})

export default class extends Mixins(OrderMixin) {
  @Prop() readonly orderSummary!: object
  @Prop() readonly order!: { paymentPGType: string; paymentMethod: string }

  get paymentTypeText () {
    const text = this.getPaymentTypeText(this.order.paymentPGType, this.order.paymentMethod)
    if (text) {
      return `(${text})`
    } else {
      return ''
    }
  }
}
